<template>
    <v-container>
        <v-row>
            <v-col :class="data.class">
                <span v-if="data.is_h1">
                    <h1 class="text-h3 text-md-h2" data-aos="fade-right" data-aos-delay="50" v-html="data.title"></h1>
                </span>
                <span v-else>
                    <h2 class="text-h3 text-md-h2" data-aos="fade-right" data-aos-delay="50" v-html="data.title"></h2>
                </span>
                <h3 class="text-h5 text-md-h4 my-3" data-aos="fade-right" data-aos-delay="150" v-if="data.sub_title" v-html="data.sub_title"></h3>
            </v-col>
            <v-col cols="12" data-aos="fade-right" data-aos-delay="50" v-if="data.has_button">
                <v-hover>
                    <template v-slot:default="{ isHovering, props }">
                        <v-btn 
                            :to="(data.button.route)  ? data.button.route :data.button.link" 
                            class="btn-primelinks bg-transparent" 
                            v-bind="props"
                            variant="text" 
                            :class="isHovering ? '' : 'ps-0'" 
                            :color="data.button.color">
                            <span class="text-underline">{{data.button.text}}</span>
                            <v-icon class="ms-3">{{data.button.icon}}</v-icon>
                        </v-btn>
                    </template>
                </v-hover>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
export default{
    props:{
        data:{
            required: true,
            type: Object,
        }
    }
}
</script>